export default class LevelPageItems {
    current = 0;
    pages = 0;
    size = 0;
    total = 0;
    pid = 0;
    pName = "层级选择";
}
